import React from 'react';
import {
  UseInboxUnreadCount,
  useInboxUnreadCount,
} from 'src/SharedCustomHooks/UseInboxUnreadCount/useInboxUnreadCount';
import { useCountdownSeconds } from 'src/SharedCustomHooks/UseCountdownSeconds/useCountdownSeconds';
import { formatRefreshCountdown } from './helpers';
import './inbox-refresh-indicator.scss';

interface InboxRefreshIndicatorProps {
  condensed?: boolean;
}

const InboxRefreshIndicator = ({
  condensed = false,
}: InboxRefreshIndicatorProps) => {
  const { nextRefreshAt }: UseInboxUnreadCount = useInboxUnreadCount();

  const secondsRemaining: number = useCountdownSeconds(nextRefreshAt);

  if (nextRefreshAt === null) {
    return null;
  }

  const label: string = formatRefreshCountdown(secondsRemaining, condensed);

  return (
    <span
      className={
        condensed
          ? 'inbox-refresh-indicator condensed'
          : 'inbox-refresh-indicator'
      }
    >
      <span className="refresh-dot" />
      <span className="refresh-label">{label}</span>
    </span>
  );
};

export default InboxRefreshIndicator;